exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.login-outer[data-v-ef68022e] {\n  width: 100%;\n}\ndiv.login-inner[data-v-ef68022e] {\n  width: 200px;\n  margin: 0 auto;\n}\ndiv.login-inner h4[data-v-ef68022e] {\n  text-align: center;\n}\ndiv.reset-reminder[data-v-ef68022e] {\n  text-align: center;\n  font-size: 0.8rem;\n  width: 100%;\n}\n.input-text[data-v-ef68022e] {\n  width: 100%;\n  margin-top: 4px;\n  margin-bottom: 8px;\n}\n.login-button[data-v-ef68022e] {\n  width: 80%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  margin-left: 10%;\n  margin-right: 10%;\n}\n.reset-button[data-v-ef68022e] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n", ""]);

// exports
